import { bodySmall } from '@monorepo/shared/styles/text';
import { EdpAnalyticsSyncResponse } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { Button } from '../../Button';
import { Footer } from '../../Footer';
import { AnalyticsSyncActiveChip } from './AnalyticsSyncActiveChip';
import { useHandleStopSync } from './buttonHandlers/useHandleStopSync';
import { useHandleSyncNow } from './buttonHandlers/useHandleSyncNow';
import { CopySqlButton } from './CopySqlButton';

const SnowflakeTableName = styled.div`
  ${bodySmall}
  color: ${({ theme }) => theme.colors.gray333};
`;

const ButtonWithRightMargin = styled(Button)`
  margin-right: 1rem;
`;

const StyledCopySqlButton = styled(CopySqlButton)`
  margin-right: 1rem;
`;

const StyledAnalyticsSyncActiveChip = styled(AnalyticsSyncActiveChip)`
  margin-left: 1rem;
`;

type AnalyticsSyncFooterProps = {
  analyticsSync: EdpAnalyticsSyncResponse;
  datasetId: string;
  organizationId: string;
  datasetOriginLabel: string;
};

export function AnalyticsSyncFooter({
  analyticsSync,
  datasetId,
  organizationId,
  datasetOriginLabel,
}: AnalyticsSyncFooterProps) {
  const handleStopSync = useHandleStopSync(datasetOriginLabel);
  const handleSyncNow = useHandleSyncNow();

  const snowflakeTableName =
    analyticsSync.outputDataset.materializationName.toUpperCase(); // Snowflake tables use uppercase

  return (
    <Footer
      leftActions={
        <>
          <ButtonWithRightMargin
            color="primary"
            variant="outlined"
            onClick={() => handleSyncNow(datasetId, organizationId)}
          >
            Sync now
          </ButtonWithRightMargin>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => handleStopSync(datasetId, organizationId)}
          >
            Stop syncing
          </Button>
        </>
      }
      rightActions={
        <>
          <StyledCopySqlButton
            datasetOriginLabel={datasetOriginLabel}
            datasetId={datasetId}
            organizationId={organizationId}
          />
          <SnowflakeTableName>
            Snowflake ID: {snowflakeTableName}
          </SnowflakeTableName>
          <StyledAnalyticsSyncActiveChip />
        </>
      }
    />
  );
}
